import React from 'react';
import get from 'lodash/get';
import MiniPlayer from 'components/MiniPlayer/MiniPlayer';
import { connect } from 'react-redux';
import miniPlayerSelector  from 'selectors/miniPlayer';
import { toggleMiniPlayerVideo } from 'actions/InCall/InCallVideo';
import { injectIntl } from 'react-intl';
import { hooks } from '@lifesize/clients.sdk';

const mapDispatchToActions = dispatch => ({
  onEndCallClick: () => window.webClientApi.endCall(),
  onToggleAudioClick: () => window.webClientApi.toggleAudio(),
  onGoBackClick: () => window.desktopApp.activateMainWindow(),
  onSwitchViewClick: () => dispatch(toggleMiniPlayerVideo())
});

const MiniPlayerContainer =
  injectIntl(connect(miniPlayerSelector, mapDispatchToActions)(MiniPlayer));

function MiniPlayerNew() {
  const call = hooks.useCallState();
  const conferenceInfo = hooks.useConferenceInfo();
  const media = hooks.useMedia();
  const currentUserModerator = hooks.useIsCurrentUserModerator();
  const isMutedByServer = get(conferenceInfo, 'serverMuteState');
  const isAudioEnabled = !get(media, 'localAudioMuted') && !isMutedByServer;
  const remoteStreams = hooks.useRemoteStreams();

  return (
    <MiniPlayerContainer
      isAudioEnabled={isAudioEnabled}
      isModerator={currentUserModerator}
      isMutedByServer={isMutedByServer}
      localVideoDeviceId={get(media, 'videoDevice.deviceId')}
      startTime={call.startTime}
      title={conferenceInfo.displayName}
      remoteVideoStream={remoteStreams.length ? remoteStreams[0] : {}}
    />
  )
}

export default MiniPlayerNew;
